import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45c67130")

_pushScopeId("data-v-45c67130")
const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 0,
  id: "alert"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Fehler:")
], -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Warnungen:")
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "errors",
  id: "alert"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_GenericDialog = _resolveComponent("GenericDialog")

  return (_openBlock(), _createBlock(_component_GenericDialog, {
    header_text: "Endpunkte importieren",
    onClose: _ctx.close,
    max_width: "800px",
    buttons: _ctx.buttons,
    onClicked: _ctx.handleButtonClick
  }, {
    default: _withId(() => [
      (_ctx.waiting)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingSpinner)
          ]))
        : (_ctx.showInfo)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: {success: !_ctx.warning, warning: _ctx.warning, error: _ctx.error}
            }, [
              (_ctx.alertText)
                ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.alertText), 1))
                : _createCommentVNode("", true),
              (_ctx.notReachableEPs.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notReachableEPs, (endpoint) => {
                        return (_openBlock(), _createBlock("li", {
                          key: endpoint[0].name,
                          class: "errors"
                        }, [
                          _createVNode("label", null, _toDisplayString(endpoint[0].name) + " kann nicht importiert werden. (" + _toDisplayString(endpoint[2]) + ") ", 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alrExistingEPs.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alrExistingEPs, (endpoint) => {
                        return (_openBlock(), _createBlock("li", {
                          key: endpoint[0].name
                        }, [
                          _createTextVNode(" Der Endpunkt \"" + _toDisplayString(endpoint[0].name) + "\" (URL: " + _toDisplayString(endpoint[0].url) + ") existiert bereits. ", 1),
                          (endpoint[0].name != endpoint[2])
                            ? (_openBlock(), _createBlock("label", _hoisted_7, [
                                _hoisted_8,
                                _createTextVNode("Er ist unter dem Namen \"" + _toDisplayString(endpoint[2]) + "\" zu finden. ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    (_ctx.warningText)
                      ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.warningText), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createBlock("div", _hoisted_10, [
              (_ctx.alertText)
                ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.alertText), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode("textarea", {
                id: "importTextArea",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.importString = $event)),
                rows: "4"
              }, null, 512), [
                [_vModelText, _ctx.importString]
              ])
            ]))
    ]),
    _: 1
  }, 8, ["onClose", "buttons", "onClicked"]))
})